import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { companyProfile } from '../content/siteContent';

const workHighlights = [
  {
    title: 'Business Website Launches',
    summary:
      'Modern company websites, service pages, and landing experiences designed to improve credibility and help visitors convert faster.',
    outcomes: 'Responsive layouts, stronger first impressions, and inquiry-focused structure.'
  },
  {
    title: 'Web And App Product Builds',
    summary:
      'Frontend and backend implementation for dashboards, custom web systems, and mobile app experiences aligned to practical business goals.',
    outcomes: 'Scalable architecture, cleaner user journeys, and smoother product execution.'
  },
  {
    title: 'SEO And Visibility Growth',
    summary:
      'Search-ready page structures, service keywords, and on-page optimization that help brands get discovered more consistently online.',
    outcomes: 'Better search visibility, more relevant traffic, and stronger local presence.'
  },
  {
    title: 'Guidance And Career Support',
    summary:
      'Visa guidance and job placement support designed to help students and professionals move forward with more clarity and confidence.',
    outcomes: 'Clearer process support, better preparation, and stronger next-step planning.'
  }
];

const engagementSteps = [
  'Understand the business goal, audience, and service priority.',
  'Shape the structure, design direction, and user journey.',
  'Build with performance, mobile experience, and clarity in mind.',
  'Refine for launch-readiness, visibility, and lead generation.'
];

function OurWork() {
  return (
    <div className="inner-page">
      <Seo
        title="Our Work | Vedanskrix Website, App, SEO, Visa & Career Projects"
        description="Explore the type of work Vedanskrix delivers across website design, web development, mobile apps, SEO, visa guidance, and job placement support."
        keywords={[
          'Vedanskrix our work',
          'website design portfolio Ahmedabad',
          'web development work Ahmedabad',
          'SEO work Ahmedabad',
          'visa and career support services Ahmedabad'
        ]}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: 'Vedanskrix Our Work',
          url: `${companyProfile.websiteUrl}/our-work`,
          description: 'Overview of Vedanskrix project categories and delivery approach.'
        }}
      />

      <section className="page-hero">
        <p className="eyebrow">Our Work</p>
        <h1>Work that connects brand presentation, execution quality, and business outcomes.</h1>
        <p>
          Vedanskrix supports brands, students, and professionals through focused digital builds,
          visibility improvements, and guidance-led services that are designed to move people
          forward with clarity.
        </p>
      </section>

      <section className="section">
        <div className="feature-grid">
          {workHighlights.map((item, index) => (
            <article key={item.title} className="feature-card">
              <span className="feature-code">0{index + 1}</span>
              <h3>{item.title}</h3>
              <p>{item.summary}</p>
              <p>{item.outcomes}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="section section-light">
        <div className="section-heading">
          <p className="eyebrow">How We Work</p>
          <h2>Each project follows a focused path from goal to delivery.</h2>
        </div>

        <div className="capability-grid">
          {engagementSteps.map((step, index) => (
            <article key={step} className="capability-card">
              <span className="check-badge">0{index + 1}</span>
              <p>{step}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="cta-banner">
          <div>
            <p className="eyebrow">Start Your Project</p>
            <h2>Want your brand or service to be featured here next?</h2>
          </div>
          <Link to="/contact" className="button-primary">
            Talk To Vedanskrix
          </Link>
        </div>
      </section>
    </div>
  );
}

export default OurWork;
